var LongObjectMapModal = (function (base) {
  __extends(LongObjectMapModal, base);

  function LongObjectMapModal(apiClient) {
    const self = base.call(this, apiClient) || this;
    return self;
  }

  /**
   * 
   * @param {} coordinates Массив координат или CSV
   * @param {} roadName Название дороги
   */
    LongObjectMapModal.prototype.activate = function (longObjectId, roadId, longObjectName, roadStartKm, startKm, stopKm) {
    const self = this;
    const url = longObjectId ? `api/longObjects/${longObjectId}/edit/map/${roadId}` : `api/longObjects/add/map/${roadId}`

    this.loadContent(url, { longObjectName: longObjectName || 'протяженного объекта' })
      .then($modal => {

        // Инициализация карты после открытия модального окна
        var mapObjects = {};
        var containerHeight = $(window).height() * 0.65;
        $('#marker-map', $modal).height(containerHeight);

        setTimeout(function () {
            mapObjects = initPolylineMap(new L.FeatureGroup(), $('[js=back]', $modal), roadStartKm, startKm, stopKm);
        }, 200);

        $modal
          .on('click', '[js=save]', () => {
            if (mapObjects.points.length < 2) {
              alert('Протяженный объект не указан.');
              return;
            }
            this.close({
              ok: true,
              startKm: Math.round(mapObjects.startKm) / 1000,
              stopKm: Math.round(mapObjects.endKm) / 1000
            });
          });
      });
  };

  return LongObjectMapModal;
}(BaseModal));
